import React from "react";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Navbar";

export default function TermsAndCondition() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="text-white text-2xl py-8 lg:px-12 sm:px-12 px-4 flex items center bg-[#2EBAA3] font-[Roboto]">
        <span>ProLegion’s Terms & Conditions</span>
      </div>

      <div className="flex md:flex-row flex-col font-[Roboto] grow">
        {/* Left Bar */}
        <div className="md:px-12 px-8 md:space-y-1 py-8">
          <li className="cursor-pointer whitespace-nowrap">
            Personal Identification System
          </li>
          <li className="cursor-pointer whitespace-nowrap">Our Services</li>
          <li className="cursor-pointer whitespace-nowrap">Responsibilities</li>
          <li className="cursor-pointer whitespace-nowrap">
            Acceptance of Terms
          </li>
          <li className="cursor-pointer whitespace-nowrap">
            Additional Service Details
          </li>
          <li className="cursor-pointer whitespace-nowrap">
            Marketing Communications
          </li>
          <li className="cursor-pointer whitespace-nowrap">Privacy Policy</li>
          <li className="cursor-pointer whitespace-nowrap">
            Submission & Proceedings
          </li>
          <li className="cursor-pointer whitespace-nowrap">User Postings</li>
          <li className="cursor-pointer whitespace-nowrap">
            Third Party Websites
          </li>
          <li className="cursor-pointer whitespace-nowrap">
            Marketing Communications
          </li>
        </div>

        {/* Right Bar */}
        <div
          style={{ backgroundColor: "#EDFDF9" }}
          className="text-sm text-gray-600 text-justify py-8 md:px-12 px-8"
        >
          <p>
            Please read these Terms and Conditions ("Agreement", "Terms and Conditions") carefully before using www.prolegion.com ("the Site") operated by ProLegion Inc. doing business as ProLegion ("us", "we", or "our"). This Agreement sets forth the legally binding terms and conditions for your use of the Site at www.prolegion.com
          </p>
          <p>
            By accessing or using the Site in any manner, including, but not limited to, visiting or browsing the Site or contributing content or other materials to the Site, you agree to be bound by these Terms and Conditions. Capitalized terms are defined in this Agreement.
          </p>
          <p>
            These Terms, and any rights and licenses granted hereunder, may not be transferred or assigned by you, but may be assigned by ProLegion without restriction. Any attempted transfer or assignment in violation hereof shall be null and void.
          </p>
          <div className="font-medium text-black pt-3">Acceptance of Terms and Conditions and Amendments</div>
          Each time you use or cause access to this web site, you agree to be bound by these Terms and Conditions, and as amended from time to time with or without notice to you. In addition, if you are using a particular service on or through this web site, you will be subject to any rules or guidelines applicable to those services and they shall be incorporated by reference into these Terms and Conditions. Please see our Privacy Policy, which is incorporated into these Terms and Conditions by reference.

          <div className="font-medium text-black pt-3">Our Service</div>
          Our web site and services provided to you on and through our web site on an "AS IS" basis. You agree that the owners of this web site exclusively reserve the right and may, at any time and without notice and any liability to you, modify or discontinue this web site and its services or delete the data you provide, whether temporarily or permanently. We shall have no responsibility or liability for the timeliness, deletion, failure to store, inaccuracy, or improper delivery of any data or information.

          <div className="font-medium text-black pt-3">Your Responsibilities and Registration Obligations</div>
          In order to use this web site, you must register on our site, agree to provide truthful information when requested, and be at least the age of eighteen (18) or older. When registering, you explicitly agree to our Terms and Conditions and as may be modified by us from time to time and available here.

          <div className="font-medium text-black pt-3">Additional Service Details</div>
          <p className="mb-5">
            ProLegion takes every minute detail in high regards, and would ask you to read on to know more about our strict terms and conditions, making our site the safest IT specialist service online to maintain those standards the following information is applicable to every user of our site.
          </p>
          <p>
            a. ProLegion would not and is not responsible for lack of matches made to requested services or the lack of completed services
          </p>
          <p>
            b. ProLegion takes no responsibility on individual matters made to request a service(s) or the lack of completed service(s)
          </p>
          <p>
            c. ProLegion does not perform background checks or personal checks for the client
          </p>
          <p>
            d. Only with the permission of the client, would personal contact details, email addresses, telephone numbers, addresses and status quo of the candidate would be shared, not otherwise.

          </p>
          <p>
            e. ProLegion has no responsibility over the vendors associated with the portal, their offers, services and products. Personal checks on behalf of the client on the vendors status quo is not the responsibility of ProLegion
          </p>
          <p>
            f. Client requirements would be honored, and specifications for the matches to services would be taken into high esteem, but we cannot guarantee any set on the number of introductions made
          </p>
          <p>
            g. Post the introduction, it is left to the client to contact one another, through any form they deem fit, ProLegion wouldn’t involve itself in the process or wouldn’t take responsibility for the same
          </p>
          <p>
            It is important to keep goodwill in the community, and especially a life-long commitment of trust, honor and respect for two individuals whether it be a vendor/client relationship or client/service provider relationship.
          </p>
          <div className="font-medium text-black pt-3">Privacy Policy</div>
          <p>
            Registration data and other personally identifiable information that we may collect is subject to the terms of our Privacy Policy.
          </p>
          <div className="font-medium text-black pt-3">Registration and Password</div>
          <p>
            You are responsible to maintain the confidentiality of your password and shall be responsible for all uses via your registration and/or login, whether authorized or unauthorized by you. You agree to immediately notify us of any unauthorized use or your registration, user account or password.
          </p>

          <p className="mt-8">
            This Agreement was last modified on March 01, 2018
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}
